var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    attrs: {
      data: _vm.score_statement,
      columns: _vm.columns,
      "row-key": "name",
      pagination: _vm.pagination,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t(col.label)) + "\n        "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            [
              _c("q-td", { key: "score_date", attrs: { props: props } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.fDate(props.row.score_date)) +
                    "\n        "
                )
              ]),
              _c("q-td", { key: "title", attrs: { props: props } }, [
                _vm._v(
                  "\n            " + _vm._s(props.row.title) + "\n        "
                )
              ]),
              _c("q-td", { key: "score", attrs: { props: props } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(props.row.score ? props.row.score.toFixed(2) : "") +
                    "\n        "
                )
              ])
            ],
            1
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }